import React, { CSSProperties, FC } from 'react';

import CopiesListContainer from './CopiesListContainer';
import { UsageCondition } from '../../../models/Product';
import { CopiesListDropdown, InjectedProps } from './CopiesListDropdown';

type Props = {
    readonly product: any;
    readonly className?: string;
    readonly label?: string;
    readonly disabled?: boolean;
    readonly styleBox?: CSSProperties;
    readonly styleArrow?: CSSProperties;
    readonly removeCopyHint?: string;
    readonly onRemoveCopy?: (copyId: number) => void;
    readonly usageCondition?: UsageCondition;
};

/**
 * @deprecated
 */
const CopiesListInfoButton: FC<Props> = ({
    product,
    label,
    disabled,
    removeCopyHint,
    onRemoveCopy,
    usageCondition,
    className
}) => {
    if (!product.netValue && product.netValue !== 0) {
        // this is a withdrawn/unavailable product!
        return null;
    }

    return (
        <CopiesListDropdown label={label} className={className}>
            {({ setShowDropDown }: InjectedProps) => (
                <CopiesListContainer
                    product={product}
                    disabled={disabled}
                    removeCopyHint={removeCopyHint}
                    onRemoveCopy={onRemoveCopy}
                    usageCondition={usageCondition}
                    setShowDropDown={setShowDropDown}
                />
            )}
        </CopiesListDropdown>
    );
};

export default CopiesListInfoButton;
